import React, { useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Gönderi metni: üç satırdan uzunsa kısaltılır, "…daha fazla" tüm metni aynı yerde açar (LinkedIn
 * düzeni). Kısaltma CSS ile; düğme yalnız metin gerçekten taştığında görünür.
 */
export default function FeedPostText({ text }: { text: string }) {
  const { t } = useTranslation('leagues');
  const ref = useRef<HTMLParagraphElement>(null);
  const [open, setOpen] = useState(false);
  const [overflow, setOverflow] = useState(false);

  useLayoutEffect(() => {
    const node = ref.current;
    if (!node || open) return undefined;
    const measure = () => setOverflow(node.scrollHeight > node.clientHeight + 1);
    measure();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(node);
    return () => observer.disconnect();
  }, [text, open]);

  return (
    <div className="feed-post__body">
      <p ref={ref} className={`feed-post__text${open ? '' : ' is-clamped'}`}>
        {text}
      </p>
      {overflow && !open && (
        <button type="button" className="feed-post__expand" onClick={() => setOpen(true)}>
          {t('detail.feed.readMore')}
        </button>
      )}
    </div>
  );
}
